import { IComponentWrapper } from '@src/slide/content-viewer/service/canvas-renderer/core/canvas-render/elements/component-wrapper.interface';
import { UIModelType } from '@src/slide/domain/ui-model/element-modeles/constant';
import type { RendererGroupComponent } from '@src/slide/content-viewer/service/canvas-renderer/core/canvas-render/elements/renderer-group-component';
import type { RendererImageComponent } from '@src/slide/content-viewer/service/canvas-renderer/core/canvas-render/elements/renderer-image-component';
import { isAttachmentShapeModel } from '@src/slide/domain/ui-model/elements/element-judge';
import { judgeParagraphListIsEmpty } from '@src/slide/domain/ui-model/element-modeles/shape-model';
import { IShapeModel } from '@src/slide/domain/ui-model/element-modeles/Interface/shape-model.interface';
import type { RendererShapeComponent } from '@src/slide/content-viewer/service/canvas-renderer/core/canvas-render/elements/renderer-shape-component';
import {
    getHasCustomPrompt,
    getIsCustomPlaceholder, isPlaceHolderShow,
} from '@editor/src/page/index/components/canvas/element-types/shape-element/utils';
import { pxToRealPt } from '@src/slide/infrastructure/module/independent/unit';
import { ReadonlyBounds } from '@tencent/alloy-renderer';
import { IFrame } from '@src/slide/domain/ui-model/element-modeles/property/frame/frame.interface';

// 变更图片的visible （处理以下场景：编辑区的gif在非选中态的visible是false，截图时不可见）
export function changeVisibleStatus(componentArr: IComponentWrapper[], visible?: boolean) {
    componentArr.forEach((component) => {
        const wrapper = component.wrapperInstance;
        const model = wrapper?.factoryOptions?.model;
        // 组合
        if (model?.type === UIModelType.GROUP) {
            const groupComponent = wrapper.children?.[0] as RendererGroupComponent;
            if (groupComponent?.children) {
                changeVisibleStatus(groupComponent.children as IComponentWrapper[], visible);
            }
            return;
        }
        // gif
        if (model?.type === UIModelType.IMAGE) {
            (wrapper.children?.[0] as RendererImageComponent)?.foregroundComponent?.dealVisibleStatus(visible);
        }
        // 本地附件
        if (isAttachmentShapeModel(model)) {
            wrapper.dealVisibleStatus(visible);
        }
        // 无内容的placeholder，且类型必须为Shape。图片/表格可能是占位符，但有内容后type会变成对应类型
        if (
            model?.isPlaceholder
            && judgeParagraphListIsEmpty((model as IShapeModel).paragraphList)
            && model?.type === UIModelType.SHAPE
        ) {
            const placeHolderComponent = (wrapper.children?.[0] as RendererShapeComponent)?.placeHolderComponent;
            if (placeHolderComponent) {
                placeHolderComponent.visible = !visible;
            }
        }
    });
}

export function isPlaceHolder(factoryOptions) {
    const { model, region } = factoryOptions;
    // 是否是通过ph插入的element
    const isCustomPlaceholder = getIsCustomPlaceholder(model);
    // 用户是否修改过ph的默认显示文案
    const hasCustomPrompt = getHasCustomPrompt(model);

    // 是否显示ph
    return isPlaceHolderShow(
        isCustomPlaceholder,
        false,
        model,
        hasCustomPrompt,
        model.isPlaceholder,
        region,
    );
}

export function calculateFrame(bounds: ReadonlyBounds, slideLeft: number, slideTop: number) {
    return {
        left: Number(pxToRealPt(bounds.x - slideLeft).toFixed(2)),
        top: Number(pxToRealPt(bounds.y - slideTop).toFixed(2)),
        width: Number(pxToRealPt(bounds.width).toFixed(2)),
        height: Number(pxToRealPt(bounds.height).toFixed(2)),
    };
}

export function calculateUiModelFrame(frame: IFrame) {
    // 1920为tdoc默认宽度，1280为office分析时的宽度
    const snapshotRatio = 1920 / 1280;
    return {
        left: Number(pxToRealPt(frame.left / snapshotRatio).toFixed(2)),
        top: Number(pxToRealPt(frame.top / snapshotRatio).toFixed(2)),
        width: Number(pxToRealPt(frame.width / snapshotRatio).toFixed(2)),
        height: Number(pxToRealPt(frame.height / snapshotRatio).toFixed(2)),
    };
}
